import { Currency, CurrencySymbol } from 'core/payments/entities';

export enum BillingPeriodUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum OfferStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  ARCHIVED = 'archived',
}

export enum PaymentAction {
  AUTH_0_AMOUNT = 'auth_0_amount',
  AUTH_VOID = 'auth_void',
  AUTH_SETTLE = 'auth_settle',
}

export type BillingPeriod = {
  unit: BillingPeriodUnit;
  value: number;
};

export type Offer = {
  id: string;
  offerId: string;
  description: string;
  currency: Currency;
  currencySymbol: CurrencySymbol;
  minorUnits: number;
  price: number;
  priceWithCurrency: string;
  period: string;
  trial: boolean;
  trialPrice: number;
  trialPriceWithCurrency: string;
  trialPeriod: string | null;
  pricesPerPeriod: {
    day: number;
    week: number;
    month: number;
  };
  trialPricesPerPeriod: {
    day: number;
    week: number;
    month: number;
  };
  type: string;
  creditsAmount: number;
};

// TODO: Remove once every funnel resolves offers by group key
export type OfferContentBase<T = Record<string, unknown>> = {
  offerIdsToMatch: Array<string>;
} & T;

// TODO: Remove together with OfferContentBase
export type OfferWithContentBase<T = Record<string, unknown>> = Offer &
  Omit<OfferContentBase<T>, 'offerIdsToMatch'>;

export const sortOffers = (offers?: Array<Offer>) => {
  if (!offers) {
    return [];
  }

  return [...offers].sort((offer1, offer2) => offer1.trialPrice - offer2.trialPrice);
};
